import React from 'react'
import DotSpinner from './Spinner'
import './SuspenseLoader.css'

const SuspenseLoader = () => {
    return (
        <>
        <p className='fallback-message'>Please wait loading...</p>
        <DotSpinner />
        </>
    )
}

export default SuspenseLoader
